import { ActivityIndicator, Text, View } from 'react-native';
import { styles } from './StudioSpotsCard.styles';
import { useStudioSpotsCard } from './useStudioSpotsCard';

export default function StudioSpotsCard() {
  const { data, isLoading, isError } = useStudioSpotsCard();
  const totalSpots = data ? data.spots.length : 0;
  const bookableSpots = data ? data.spots.filter((spot) => spot.bookable).length : 0;
  const firstSpot = data?.spots[0];

  return (
    <View style={styles.card} testID="studio-spots-card">
      <Text style={styles.title} testID="studio-spots-title">
        Studio Spots
      </Text>
      <Text style={styles.subtitle} testID="studio-spots-subtitle">
        Live availability snapshot
      </Text>
      {isLoading && (
        <View testID="studio-spots-loading">
          <ActivityIndicator />
        </View>
      )}
      {isError && !isLoading && (
        <Text style={styles.error} testID="studio-spots-error">
          Failed to load studio data.
        </Text>
      )}
      {!isLoading && !isError && data && (
        <View testID="studio-spots-data">
          <Text style={styles.metricLabel} testID="studio-spots-name">
            {data.name}
          </Text>
          <View style={styles.metricRow} testID="studio-spots-metrics">
            <Text style={styles.metricValue}>Total: {totalSpots}</Text>
            <Text style={styles.metricValue}>Bookable: {bookableSpots}</Text>
          </View>
          {firstSpot && (
            <Text style={styles.status} testID="studio-spots-first">
              First spot: {firstSpot.type} ({firstSpot.x},{firstSpot.y})
            </Text>
          )}
        </View>
      )}
    </View>
  );
}
